import { RESPONSE_STATUS, RESPONSE_STATUS_JA, LANGUAGE } from '../../constants';
import type { ValueGetterParams } from 'ag-grid-community';
import type { Language, SelectOption } from '../../types/common';

/**
 * responseStatusの値からフィルタ用の文字列を生成する（valueはnull/'0'/'1'/'2'）。
 * 0: 未回答 1: 継続 2: 解除とする。
 * 解決できなかった場合はvalueをstringとして返す。
 * @param params [ValueGetterParams]
 * @returns string
 */
const responseStatusFilterValueGetter = (params: ValueGetterParams) => {
  const value: string = params.getValue('responseStatus');
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const filterValue: string = currentLang ? (currentLang.value === LANGUAGE.JA ? RESPONSE_STATUS_JA[value] : RESPONSE_STATUS[value]) : value;
  return filterValue;
};

export default responseStatusFilterValueGetter;
